module.exports = __webpack_public_path__ + "img/potion_img_02.89fdecde.png";